import { render, staticRenderFns } from "./Wiki.vue?vue&type=template&id=3ca3f4fc&scoped=true&"
import script from "./Wiki.vue?vue&type=script&lang=js&"
export * from "./Wiki.vue?vue&type=script&lang=js&"
import style0 from "./Wiki.vue?vue&type=style&index=0&id=3ca3f4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3f4fc",
  null
  
)

export default component.exports